// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1T3bD","large":"styles_large__1ouTz"};